module.exports = __webpack_public_path__ + "media/assets/images/logo-8a13c9d196f505afef40b022e5509692.svg";